/* eslint-disable no-shadow */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { toast } from 'react-toastify';
import Loader from 'components/common/Loader';
import ActionsFormatter from 'components/ActionsFormatter';
import { defaultDeleteFilter } from 'utils/constants';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { indianSubscriptionPlansColumns } from 'pages/SubscriptionPlans/constant';
import {
  SUBSCRIPTION_PLANS_QUERY,
  UPDATE_SUBSCRIPTION_PLAN,
} from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { FaCheck } from 'react-icons/fa6';
import SubscriptionPlanMobileList from 'pages/SubscriptionPlans/components/SubscriptionPlanMobileList';

const IndianSubscriptionPlansTable = ({
  searchString,
  toggleDeleteRecord,
  handleClickEdit,
}) => {
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'planName',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      {
        key: 'currency',
        value: 'INR',
        type: 'STRING',
        op: 'EQ',
      },
      {
        key: 'isAddOn',
        value: true,
        type: 'BOOLEAN',
        op: 'NEQ',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'planName',
    sortDirection: 'DESC',
    pagination: true,
  });

  const { data, loading, error, refetch } = useQuery(SUBSCRIPTION_PLANS_QUERY, {
    variables: {
      ...filters,
      filter: [...filters.filter],
    },
    fetchPolicy: 'network-only',
  });

  const [updateSubscriptionPlan] = useMutation(UPDATE_SUBSCRIPTION_PLAN, {
    onCompleted: ({ updateSubscriptionPlan }) => {
      toast.success(updateSubscriptionPlan?.message);
      refetch();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors?.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });
  // useEffect(() => {
  //   const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
  //   const unsubscribe = subscribeToMore({
  //     document: CATEGORY_LIST_SUBSCRIPTION,
  //     variables: { ...filters, filter: deletedObj },
  //     updateQuery: (prev, { subscriptionData }) => {
  //       const newData = cloneDeep(prev);
  //       const indexFound = newData.categoryList.categoryList.findIndex(
  //         (val) => val.id === subscriptionData.data?.categoryList?.category?.id
  //       );
  //       if (!prev || isEmpty(prev)) return '';
  //       if (!subscriptionData.data) return prev;
  //       if (!subscriptionData.data?.categoryList?.category?.id) return prev;
  //       if (subscriptionData.data.categoryList.action === 'CREATED') {
  //         const newCategoryList = subscriptionData.data.categoryList.category;
  //         const updatedCategoryList = [
  //           newCategoryList,
  //           ...newData.categoryList.categoryList,
  //         ];

  //         const newTotalCount = prev.categoryList.totalCount + 1;
  //         const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

  //         newData.categoryList = {
  //           ...newData.categoryList,
  //           totalCount: newTotalCount,
  //           totalPages: newTotalPages,
  //           categoryList: updatedCategoryList,
  //         };
  //       }
  //       if (subscriptionData.data.categoryList.action === 'UPDATED') {
  //         newData.categoryList.categoryList[indexFound] =
  //           subscriptionData.data.categoryList.category;
  //       }

  //       if (subscriptionData.data.categoryList.action === 'DELETED') {
  //         const { id } = subscriptionData.data.categoryList.category; // ID of the category to remove
  //         const prevCategoryList = prev.categoryList.categoryList;

  //         const updatedCategoryList = prevCategoryList.filter(
  //           (val) => val.id !== id
  //         );

  //         const newTotalCount = prev.categoryList.totalCount - 1;
  //         const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

  //         const updatedCategoryListData = {
  //           ...newData.categoryList,
  //           totalCount: newTotalCount,
  //           totalPages: newTotalPages,
  //           categoryList: updatedCategoryList,
  //         };

  //         newData.categoryList = updatedCategoryListData;
  //       }

  //       return newData;
  //     },
  //   });

  //   return () => unsubscribe();
  // }, []);

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        handleDelete={() =>
          toggleDeleteRecord(cell?.row?.original?.id, refetch)
        }
        handleEdit={() => handleClickEdit(cell?.row?.original, refetch)}
      />
    );
  };

  const handleStatusChange = async (row) => {
    try {
      await updateSubscriptionPlan({
        variables: {
          updateInput: {
            id: row?.id,
            status: row?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
          },
          subscriptionPlanPriceHistoryInputDTO: {
            subscriptionPlan: row?.id,
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const statusFormatter = (cell) => {
    return (
      <div className="toggle-check cmn-toggle d-flex">
        <div className="d-inline-block position-relative">
          <input
            type="checkbox"
            onChange={() => handleStatusChange(cell?.row?.original)}
            checked={cell?.row?.original?.status === 'ACTIVE' ? true : false}
          />
          <FaCheck size={10} />
        </div>
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return indianSubscriptionPlansColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };

  indianSubscriptionPlansColumns[findIndexOfItem('actions')].cell =
    actionsFormatter;

  indianSubscriptionPlansColumns[findIndexOfItem('status')].cell =
    statusFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.subscriptionPlans?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  // const onGlobalSearch = (str) => {
  //   if (str) {
  //     setFilters((prevFilter) => {
  //       const updatedFilter = [...prevFilter.filter]; // Clone the filter array
  //       const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //       updatedFirstFilter.value = str;
  //       updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //       return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //     });
  //   }
  // };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.subscriptionPlans?.subscriptionPlans)
    return <NoDataFound message="Subcription Plans not available" />;

  return (
    <>
      <SubscriptionPlanMobileList
        plans={(data && data?.subscriptionPlans?.subscriptionPlans) || []}
        totalPages={(data && data?.subscriptionPlans?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        renderActions={(plan) => actionsFormatter({ row: { original: plan } })}
        renderStatus={(plan) => statusFormatter({ row: { original: plan } })}
      />
      <div className="subscription-mobile-hide-table">
        <FSBTable
          data={(data && data?.subscriptionPlans?.subscriptionPlans) || []}
          totalCount={(data && data?.subscriptionPlans?.totalCount) || 0}
          totalPages={(data && data?.subscriptionPlans?.totalPages) || 0}
          columns={indianSubscriptionPlansColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          // globalSearchStr={filters.filter[0].value}
          // onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search "
        />
      </div>
    </>
  );
};
export default IndianSubscriptionPlansTable;
